// This import loads the firebase namespace along with all its type information.
import MetricConfiguration from './metric-configuration-model'

export async function load_metricConfigurations(): Promise<
  MetricConfiguration[]
> {
  throw 'Not implemented'
}

export async function delete_metricConfiguration(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_metricConfiguration(): Promise<MetricConfiguration> {
  throw 'Not implemented'
}
